webpackJsonp([254231618621902],{

/***/ 1373:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":{"edges":[{"node":{"title":"Meetups You Should Check Out This Month, Part 2: Portland","metaDescription":"Looking for resources as you learn to code? The Code Fellows blog features helpful tutorials, alumni stories, student projects, school news, and more!","slug":"blog/meetups-you-should-check-out-this-month-part-2-portland","createdAt":"2015-08-07T02:33:03.769Z","blogAuthor":{"fields":{"name":"Jordana Gustafson","slug":"blog/author/jordana-gustafson"}},"imageHeader":{"fields":{"file":{"url":"//images.ctfassets.net/k428n7s2pxlu/47HLUOt5600Woi8SI0CMGg/0a94723491ce929c422c4ac56c9bcc38/blog-post-blog-meetups-you-should-check-out-this-month-part-2-portland.png"}}}}}]},"authorJson":{"name":"Jordana Gustafson","slug":"blog/author/jordana-gustafson","twitter":null,"linkedIn":null,"website":null,"biography":null,"image":null}},"pathContext":{"slug":"blog/author/jordana-gustafson"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-jordana-gustafson-b2976b61fdb2e8ab55d0.js